import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import config from "../../config.json";
import axios from "axios";
import { Box } from "@mui/material";
import { GameVideo } from "../common/game-video/game-video";
import { SpecialFeaturesCard } from "../common/special-features-card/special-features-card";
import { GameCard } from "../common/game-card/game-card";

const Home = () => {
    const [serverStats, setServerStats] = useState({
        serverOnline: false,
        onlinePlayers: 0,
    });

    const fetchOnlineStatus = async () => {
        try {
            const { data } = await axios.get(config.apiEndPoint + "statistics");
            setServerStats({
                serverOnline: !!data?.serverOnline,
                onlinePlayers: data?.onlinePlayers ?? 0,
            });
        } catch (error) {
            console.error("Failed to fetch server stats:", error);
        }
    };

    useEffect(() => {
        fetchOnlineStatus();
        const interval = setInterval(fetchOnlineStatus, 30000); // Refresh every 30s
        return () => clearInterval(interval);
    }, []);

    return (
        <Box className="text-brand-white-100 min-h-screen">
            <Container>
                {/* Header & Video Section */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 py-10">
                    <div className="lg:col-span-2">
                        <GameVideo />
                    </div>

                    <div className="flex items-center justify-center">
                        <GameCard
                            title="Online Players"
                            value={serverStats.onlinePlayers}
                        />
                    </div>
                </div>

                {/* Server Info */}
                <div className="text-center py-16 bg-white text-brand-gray-100 rounded-xl shadow-md">
                    <h2 className="text-4xl font-bold uppercase mb-4">
                        Medium and Stable Server
                    </h2>
                    <p className="max-w-2xl mx-auto text-lg">
                        This is the place for you to be. Easy to get items and enjoy the classic features of Conquer Online!
                    </p>
                </div>

                {/* Feature Cards */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 py-16">
                    <SpecialFeaturesCard
                        title="Closest Experience"
                        value="Best Conquer Online experience as much as you used to experience it."
                        icon="fa-star"
                    />
                    <SpecialFeaturesCard
                        title="Fairest Ever"
                        value="FREE of battle power, favoritism, and donation items."
                        icon="fa-lightbulb-o"
                    />
                    <SpecialFeaturesCard
                        title="Simply & Clean"
                        value="Pure client 1.0 interface with high graphics engine."
                        icon="fa-podcast"
                    />
                    <SpecialFeaturesCard
                        title="Best Rate"
                        value="Medium rates & experience as it was on Conquer Online 1.0."
                        icon="fa-star"
                    />
                    <SpecialFeaturesCard
                        title="Advance Emulator"
                        value="Custom Conquer emulator for unique classic gameplay."
                        icon="fa-cog"
                    />
                    <SpecialFeaturesCard
                        title="BattlEye"
                        value="Extremely anti-cheat system with self-reporting tools."
                        icon="fa-eye"
                    />
                </div>
            </Container>
        </Box>
    );
};

export default Home;
